<template>
    <div>
        <!-- 筛选区域 -->
        <div class="filter-section">
            <div>
                <el-form :model="searchFilter" ref="projectForm" label-position="left" class="projectForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="项目代码" :label-width="labelWidth">
                                <el-input class="text-input" v-model="searchFilter.projectCode"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="项目名称" :label-width="labelWidth">
                                <el-input class="text-input" v-model="searchFilter.projectName"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="有效期起止日期" :label-width="labelWidth">
                                <el-date-picker size="large" value-format="yyyy-MM-dd"
                                    v-model="searchFilter.expiryDateMin" type="date"
                                    placeholder="选择开始时间"></el-date-picker> -
                                <el-date-picker v-model="searchFilter.expiryDateMax" value-format="yyyy-MM-dd"
                                    type="date" placeholder="选择结束时间"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="核准内容" :label-width="labelWidth">
                                <el-input class="text-input" v-model="searchFilter.content" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="完成起始日期" :label-width="labelWidth">
                                <el-date-picker size="large" value-format="yyyy-MM-dd"
                                    v-model="searchFilter.finishDateMin" type="date"
                                    placeholder="选择开始时间"></el-date-picker> -
                                <el-date-picker v-model="searchFilter.finishDateMax" value-format="yyyy-MM-dd"
                                    type="date" placeholder="选择结束时间"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="投资金额" :label-width="labelWidth">
                                <el-input class="num-size-input" v-model="searchFilter.moneyMin"
                                    placeholder=""></el-input>-
                                <el-input class="num-size-input" v-model="searchFilter.moneyMax"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="建设单位" :label-width="labelWidth">
                                <el-input class="text-input" v-model="searchFilter.companyName"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="建设内容及规模" :label-width="labelWidth">
                                <el-input class="text-input" v-model="searchFilter.scaleContent"
                                    placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="地区" :label-width="labelWidth">
                                <el-select v-model="searchFilter.province" class="seletc-size-input2"
                                    @change="areaChange($event, 'province')">
                                    <el-option v-for="item in provinceList" :key="item.areaId" :label="item.areaName"
                                        :value="item.areaId">
                                    </el-option>
                                </el-select>
                                <el-select v-model="searchFilter.city" class="seletc-size-input2"
                                    @change="areaChange($event, 'city')">
                                    <el-option v-for="item in cityList" :key="item.areaId" :label="item.areaName"
                                        :value="item.areaId">
                                    </el-option>
                                </el-select>
                                <!-- <el-select v-model="searchFilter.county" class="seletc-size-input"
                                    @change="areaChange($event, 'county')">
                                    <el-option v-for="item in countyList" :key="item.areaId" :label="item.areaName"
                                        :value="item.areaId">
                                    </el-option>
                                </el-select> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="行业" :label-width="labelWidth">
                                <el-select class="seletc-size-input-1" v-model="searchFilter.industry" placeholder="行业">

                                    <el-option v-for="item in industryList" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="btn oh mr-8 mb-2">
                    <div class="fr">
                        <el-button icon="el-icon-search" type="primary" @click="handleSearch">查询</el-button>
                        <el-button icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <ad :type="1"></ad>
        <!-- 数据表格区域 -->
        <div class="table-section">
            <div class="table-header">
                <div class="table-title">
                    <i class="el-icon-document-checked"></i>
                    <span>核准制项目</span>
                    <el-tag size="small" type="info">{{ total }} 条</el-tag>
                </div>
            </div>

            <el-table :data="tableData" stripe border v-loading="loading" class="data-table"
                :header-cell-style="headerCellStyle">
                <el-table-column prop="index" width="60" align="center" label="序号">
                    <template slot-scope="{ $index }">
                        {{ $index + 1 + (currentPage - 1) * pageSize }}
                    </template>
                </el-table-column>

                <el-table-column prop="projectCode" label="项目代码" min-width="100" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <span class="code-text">{{ row.projectCode }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="projectName" label="项目名称" min-width="100" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <el-link type="primary" :underline="false"
                            @click="handlerLinkLocal('/ApprovalNotice/detail?id=' + row.id)">
                            {{ row.projectName }}
                        </el-link>
                    </template>
                </el-table-column>

                <el-table-column prop="progress" label="城市" width="180" align="center">
                    <template slot-scope="{ row }">
                        {{ row.province }}{{ row.city }}
                    </template>
                </el-table-column>
                <el-table-column prop="progress" label="建设单位" width="180" align="center">
                    <template slot-scope="{ row }">
                        {{ row.companyName || '-' }}
                    </template>
                </el-table-column>

                <el-table-column prop="status" label="投资额" width="160" align="center">
                    <template slot-scope="{ row }">
                        {{ row.money ? row.money + row.moneyUnit : '-' }}
                    </template>
                </el-table-column>

                <el-table-column prop="approveDate" label="完成时间" width="140" align="center">
                    <template slot-scope="{ row }">
                        {{ row.finishDate }}
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="110" align="center" fixed="right">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="small" :class="row.preselectId > 0 ? 'red-color' : ''"
                            @click="togglePreselectProject(1, row)">
                            {{ row.preselectId > 0 ? '取消' : '加入' }}预选项目
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" background />
            </div>
        </div>
    </div>
</template>

<script>
import { dataInJs } from '@/utils/city.js';
export default {
    name: 'ApprovalNotice',
    data() {
        return {
            provinceList: dataInJs(),
            cityList: [],
            countyList: [],
            industryList: [],
            // 筛选条件
            labelWidth: '125px',
            searchFilter: {
                industry: '',
                projectCode: '',
                projectName: '',
                type: '',
                finishDateMin: '',
                finishDateMax: '',
                content: '',
                moneyMin: '',
                moneyMax: '',
                scaleContent: '',
                companyName: '',
                province: '',
                city: '',
                county: '',
            },

            // 表格数据
            loading: false,
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0
        }
    },
    created() {
        this.searchFilter.province = 44;
        this.cityList = this.provinceList.filter(item => item.areaId === 44)[0].children;
    },
    mounted() {
        this.fetchData();
        this.getIndustryList();
    },

    methods: {
        getIndustryList() {
            let ajaxUrl = this.$api.common.agencyService.Industry();
            this.loading = true;
            this.$axios.get(ajaxUrl).then((res) => {
                if (res.success) {
                    this.industryList = res.list;
                }
                this.loading = false;
            }).catch((err) => {
                console.error('fetchData err:', err);
                this.loading = false;
            });
        },

        //获取行业分类
        getIndustryList() {
            this.$axios.get(this.$api.common.Parameter.Industry()).then((res) => {
                console.log('行业分类', res);
                if (res.success) {
                    this.notionClassList1 = res.list;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        //省市区切换
        areaChange(val, type) {
            if (type === 'province') {
                this.cityList = this.provinceList.filter(item => item.areaId === val)[0].children;
                this.countyList = [];
                this.searchFilter.city = '';
                this.searchFilter.county = '';
            } else if (type === 'city') {
                this.countyList = this.cityList.filter(item => item.areaId === val)[0].children;
            } else if (type === 'county') {
                // 选择县区后不需要做额外操作
            }
        },

        // 表头样式
        headerCellStyle() {
            return {
                backgroundColor: '#2c5282',
                color: '#fff',
                fontWeight: 600,
                fontSize: '14px'
            }
        }, // 查询
        handleSearch() {
            this.currentPage = 1;
            this.fetchData()
        },

        // 重置
        handleReset() {
            this.searchFilter = {
                projectCode: '',
                projectName: '',
                type: '',
                finishDateMin: '',
                finishDateMax: '',
                content: '',
                moneyMin: '',
                moneyMax: '',
                scaleContent: '',
                companyName: '',
                province: '',
                city: '',
                county: '',
            }
            this.currentPage = 1
            this.fetchData();
        },

        // 获取数据
        fetchData() {
            this.loading = true;
            let ajaxUrl = this.$api.common.ApprovalNotice.List();
            let params = {
                page: this.currentPage,
                ...this.searchFilter
            }
            this.$axios.get(ajaxUrl, { params }).then((res) => {
                console.log('公告数据', res);
                this.tableData = res.list;
                this.total = res.totalRecord;
                this.loading = false;
            }).catch((err) => {
                this.loading = false
            })
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },

        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        }
    }
}
</script>

<style lang="less" scoped>
.project-approval-page {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 60px);

    // 页面头部
    .page-header {
        margin-bottom: 20px;
        padding: 0 5px;

        .header-left {
            display: flex;
            align-items: center;

            i {
                font-size: 24px;
                color: #2c5282;
                margin-right: 10px;
            }

            h2 {
                font-size: 20px;
                font-weight: 600;
                color: #1a365d;
                margin: 0;
            }
        }
    }

    // 横向时间线分类区域
    .timeline-section {
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
        margin-bottom: 20px;
        overflow: hidden;

        .timeline-container {
            display: flex;
            width: 100%;
        }

        .timeline-block {
            display: flex;
            flex-direction: column;
            border-right: 1px solid rgba(0, 0, 0, 0.08);
            min-height: 90px;

            &:last-child {
                border-right: none;
            }

            // 大分类标题
            .main-category-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 16px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.06);
                justify-content: space-around;

                .main-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #1a365d;
                }

                .main-count {
                    font-size: 12px;
                    color: #4a5568;
                    background: rgba(255, 255, 255, 0.7);
                    padding: 2px 8px;
                    border-radius: 10px;
                    min-width: 24px;
                    text-align: center;
                }
            }

            // 二级分类容器
            .sub-categories {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                padding: 12px 16px;
                flex: 1;
                align-items: center;
                justify-content: space-around;

                // 二级分类胶囊
                .sub-category-pill {
                    padding: 6px 14px;
                    border-radius: 16px;
                    font-size: 13px;
                    color: #4a5568;
                    background: #005aa817;
                    border: 1px solid #e2e8f0;
                    cursor: pointer;
                    transition: all 0.25s ease;
                    white-space: nowrap;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

                    &:hover {
                        border-color: #2c5282;
                        color: #2c5282;
                        transform: translateY(-1px);
                        box-shadow: 0 2px 6px rgba(44, 82, 130, 0.15);
                    }

                    // 选中状态 - 深蓝填充
                    &.active {
                        background: #2c5282 !important;
                        border-color: #2c5282 !important;
                        color: #fff !important;
                        box-shadow: 0 2px 8px rgba(44, 82, 130, 0.3);
                        font-weight: 500;
                    }
                }
            }
        }
    }

    // 筛选区域
    .filter-section {
        background: #fff;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

        .filter-row {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 20px;
        }

        .filter-item {
            display: flex;
            align-items: center;

            .filter-label {
                font-size: 14px;
                color: #4a5568;
                margin-right: 10px;
                font-weight: 500;
                white-space: nowrap;
            }

            &.search-item {
                flex: 1;
                max-width: 300px;
            }
        }

        .date-picker {
            width: 280px;
        }

        .location-picker {
            width: 200px;
        }

        .search-input {
            width: 100%;
        }

        .filter-actions {
            margin-left: auto;

            .el-button {
                margin-left: 10px;
            }
        }
    }
}

// 按钮主题色覆盖
::v-deep .el-button--primary {
    background: #2c5282;
    border-color: #2c5282;

    &:hover,
    &:focus {
        background: #1a365d;
        border-color: #1a365d;
    }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2c5282;
}

::v-deep .el-link.el-link--primary {
    color: #2c5282;

    &:hover {
        color: #1a365d;
    }
}
</style>
